import { render } from "./ArchivoPlaDatos.vue?vue&type=template&id=41542f1c&scoped=true"
import script from "./ArchivoPlaDatos.vue?vue&type=script&lang=js"
export * from "./ArchivoPlaDatos.vue?vue&type=script&lang=js"

import "./ArchivoPlaDatos.vue?vue&type=style&index=0&id=41542f1c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41542f1c"]])

export default __exports__